import { useRef } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/form-controls/Button";
import Input from "../../components/form-controls/Input";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import useModal from "../../hooks/useModal";
import { AccountService } from "../../services/AccountsService";
import { AlertService } from "../../services/Alert";


interface SMSModalProps {
    show: boolean;
    data: boolean;
    onRequestClose: (refresh: boolean) => void;
}

function SMSModal({ show, data, onRequestClose }: SMSModalProps) {

    const { account } = useCurrentAccount();

    const modal = useRef<HTMLDivElement>(null);

    useModal(modal, show)

    const defaultValues = {
        user: '',
        pass: '',
    }

    const { register, watch, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const submit = async (data) => {
        try {
            data.account_id = account.id;
            
            await AccountService.disconnectSMS(account.id)
            await AccountService.saveSMSSettings(data);
            await onRequestClose(true)

            reset(defaultValues)

            AlertService.toastSuccess('Se guardó correctamente la configuración')
        } catch (error) {
            console.error(error)
            AlertService.error('¡Error!', 'No se pudo guardar la configuración, intenta más tarde.')
        }
    }

    return (
        <div className="modal fade" ref={modal} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Configuración de SMS</h4>
                            <button type="button" className="btn-close" onClick={() => onRequestClose(false)}></button>
                        </div>
                        <div className="modal-body">
                            <p>Conecta tu cuenta de SMS para crear campañas y desactívala en cualquier momento.</p>

                            <div className="mb-3">
                                <Input label='Usuario *' errors={errors.user} {...register('user', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>

                            <div className="mb-3">
                                <Input label='Contraseña *' errors={errors.pass} {...register('pass', { required: true, setValueAs: (value) => value.trim() })} />
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => onRequestClose(false)}>Cancelar</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>Guardar</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default SMSModal